import React, { useContext, useMemo } from 'react'
import { AppFormsContext } from '../contexts/AppFormsContext';
import { getFormPropz } from 'global/components/forms/props/formPropz';

export const useAppForm = ({
  appFormType,
  appFormTypes,
  appFormItems,
  propIgnores,
  vit,
  data_form,
  dataPropType,
}) => {

  const appFormsContext = useContext(AppFormsContext);
  const { appForms_state } = appFormsContext ?? {}
  const { appForms } = appForms_state ?? {}

  const { formPropz } = useMemo(() => {

    let _formProps;

    const data = {
      dataPropType,
      viewProps: null,
      noProps: false,
      data_form,
      data_parent: data_form,
    }

    if (appForms) {
      if (appFormTypes) {
        let allViewProps = {}
        appFormTypes.forEach(aft => {
          if (appForms[aft]) {
            const _viewProps = appForms[aft]
            allViewProps = { ...allViewProps, ..._viewProps }
          }
        })
        if (allViewProps && propIgnores) propIgnores.forEach(pi => { delete allViewProps[pi] })
        const fpp = { updateProps: { vit }, viewProps: allViewProps, data_init: data_form }
        _formProps = getFormPropz(fpp)
        data.viewProps = allViewProps
      } else if (appFormType && appForms[appFormType]) {
        const _viewProps = appForms[appFormType]
        if (_viewProps && propIgnores) propIgnores.forEach(pi => { delete _viewProps[pi] })
        const fpp = { updateProps: { vit }, viewProps: _viewProps, data_init: data_form }
        _formProps = getFormPropz(fpp)
        data.viewProps = _viewProps
      } else if (appFormItems) {
        const fpp = { updateProps: { vit }, viewProps: appFormItems, data_init: data_form }
        _formProps = getFormPropz(fpp)
        data.viewProps = appFormItems
      } else {
        data.noProps = true
      }
    }

    const _data = { ...data, formProps: _formProps }

    return { formPropz: _data }
  }, [[appFormType, appFormTypes, appFormItems]])

  return {
    formPropz
  }
}
